import { Skeleton } from "@chakra-ui/react";
import { NavBar } from "@src/components/ui-kit";
import { Icon } from "@src/components/ui-kit/Icon";
import { AppSubNav } from "@src/components/widgets/AppSubNav/AppSubNav";
import { useExpenseNavigation } from "@src/components/widgets/AppSubNav/navigation-expense/hooks";
import { useScreenType } from "@src/utils/hooks/useIsMobile";

type NavigationExpenseProps = {
  expenseId?: string;
};
export const NavigationExpense = ({ expenseId }: NavigationExpenseProps) => {
  const { visiblePages, isLoading, activeSubpage } =
    useExpenseNavigation(expenseId);
  const { isDesktop } = useScreenType();

  return (
    <AppSubNav>
      {visiblePages.map((page) => (
        <NavBar.Item key={page.href.pathname} active={false} href={page.href}>
          {page.title()}
        </NavBar.Item>
      ))}

      {isDesktop && activeSubpage && <Icon name="chevron-right" />}

      {activeSubpage && (
        <NavBar.Item active={false} href={activeSubpage.href}>
          <Skeleton isLoaded={!isLoading}>{activeSubpage.title()}</Skeleton>
        </NavBar.Item>
      )}
    </AppSubNav>
  );
};
